import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { requestGet } from '../../api/request';
import EventMore from './EventMore';
import Map from '../Home/Map';
import * as actions from '../../redux/actions';
import { EVENT_BY_INTERNAL_POLITICS } from '../../api/url';

const EvByThemeInternalPoliticts = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [searchParams, setSearchParams] = useSearchParams();

  const [menu, setMenu] = useState([]);
  const [currentPage, setCurrentPage] = useState(+searchParams.get('page') || undefined);

  useEffect(() => {
    if (menu.data) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  const getMenues = async () => {
    setLoader(true);

    const response = await requestGet(EVENT_BY_INTERNAL_POLITICS, {
      'lang_id': currentLanguage.id,
      'page': currentPage,
    });

    if (response.success) {
      setMenu(response.data);
      setLoader(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 1) {
      searchParams.set('page', +pageNumber);
    } else {
      searchParams.delete('page');
      setCurrentPage(1);
    }
    setSearchParams(searchParams);
  };

  const handleKeyPress = () => {};

  useEffect(() => {
    if (menu.data) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  useEffect(() => {
    // Handle page url params;
    if (+searchParams.get('page') > 1) {
      setCurrentPage(+searchParams.get('page'));
    }
  }, [searchParams]);

  useEffect(() => {
    getMenues();
  }, [currentPage, currentLanguage]);

  const showDatas = () => (
    menu.data.map((data) => (
      <div key={data.id} className="col-md-6 col-xl-4">
        <div
          className="gallery-item"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/event_by_theme/internal_politics/${data.name}`);
          }}
          onKeyDown={handleKeyPress}
          role="button"
          tabIndex="0"
          aria-label="plate"
        >
          <div className="gallery-item__img">
            <img style={{ cursor: 'pointer' }} src={data.src} alt="" />
          </div>
          <div className="gallery-item__content">
            <a
              href={`/event_by_theme/internal_politics/${data.name}`}
              className="gallery-item__link"
            >
              {dictionary[data.name]}
            </a>
          </div>
        </div>
      </div>
    ))
  );

  return (
    <>
      <div className="col-lg-9">
        {loader === true ? (
          <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
            <div className="spinner-border text-success" role="status">
              <span className="sr-only" />
            </div>
          </div>
        ) : null}

        {menu.data && menu.data.length > 0 ? (
          <div className="row">
            {showDatas()}
            {menu.last_page > 1
              ? (
                <Pagination
                  activePage={currentPage || 1}
                  totalItemsCount={menu.data ? menu.total : 0}
                  onChange={(pageNumber) => handlePageChange(pageNumber)}
                  pageRangeDisplayed={14}
                  itemclassName=""
                  linkclassName=""
                  firstPageText={dictionary.pagination_prev}
                  lastPageText={dictionary.pagination_last}
                  prevPageText={dictionary.pagination_first}
                  nextPageText={dictionary.pagination_next}
                  innerClass="paginations d-lg-flex flex-wrap"
                  hideDisabled={true}
                />
              ) : null }
          </div>
        ) : null}
      </div>
      <div className="col-lg-3 pl-lg-4 d-none d-lg-block">
        <div className="saidbar">
          <div className="saidbar-content">
            <EventMore />
          </div>
        </div>
      </div>
      <Map />
    </>
  );
};

export default EvByThemeInternalPoliticts;
